import { Accordion } from "react-bootstrap";
import { JsonView, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';


function getValueByPath(obj, path) {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

function tryParseJSON(value) {
  try {
    if(typeof value === 'object') {
      return JSON.stringify(value, null, 2);
    }
    const parsed = JSON.parse(value);
    console.log("parsed >>>", parsed)
    return typeof parsed === 'object' ? JSON.stringify(parsed, null, 2) : parsed;
  } catch {
    return value;
  }
}

const FieldDiff = ({ field, before, after }) => {
  const beforeVal = tryParseJSON(before);
  const afterVal = tryParseJSON(after);
  console.log("beforeVal 2", beforeVal)
  console.log("afterVal 2", afterVal)

  return (
    <div style={{
      marginBottom: '1rem',
      padding: '1rem',
      border: '1px solid #ddd',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9',
    }}>
      <p className="m-0 text-dark"><strong>Field:</strong> {field}</p>
      <div style={{ color: 'red' }}><strong>Before:</strong> {beforeVal}</div>
      <div style={{ color: 'green' }}><strong>After:</strong> {afterVal}</div>
    </div>
  );
};

const DiffViewer = ({ diffData }) => {
  const { changedFields, before, after } = diffData.diff;

  return (
    <div>
      {changedFields.map((field, idx) => {
        const beforeVal = getValueByPath(before, field);
        const afterVal = getValueByPath(after, field);
        console.log("beforeVal", beforeVal)
        console.log("afterVal", afterVal)

        return (
          <FieldDiff
            key={idx}
            field={field}
            before={beforeVal}
            after={afterVal}
          />
        );
      })}
      <div className="my-2">
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header className="custom-accordion-header">Show Raw Metadata</Accordion.Header>
            <Accordion.Body>
              <JsonView
                data={diffData}
                shouldExpandNode={(level) => level === 0 ? true : false}
                style={defaultStyles}
                clickToExpandNode={true}
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
};

export default DiffViewer;
